import React from 'react';

import { Menu } from './use-tool-bar';

export const toolbarDivider = () => <div style={{ borderLeft: '1px solid #dee2e6', height: '100%' }}></div>;

export const getMenuDivider = (id: string | number): Menu => ({
  id: 'divider-' + id,
  currentVariant: 0,
  variants: [
    {
      Element: toolbarDivider,
      priority: Infinity,
      fullHeight: true,
    },
  ],
  hook: () => undefined,
  tempHook: () => undefined,
});

export type MenuDividerHookValue = undefined;
